import type { SchedulerRole } from '@lucid/test-drive-scheduler';
import { useUserRole } from './useUserRole';

const SCHEDULER_ADMIN_ROLES = ['LucidPartners-Lucid-Admin', 'LucidPartners-Agency-Admin'];
const SCHEDULER_MANAGER_ROLES = ['LucidPartners-Agency-Manager'];
const SCHEDULER_USER_ROLES = ['LucidPartners-Agency-User'];

export const deriveSchedulerRole = (roles: string[]): SchedulerRole | undefined => {
  if (roles.some((role) => SCHEDULER_ADMIN_ROLES.includes(role))) return 'admin';
  if (roles.some((role) => SCHEDULER_MANAGER_ROLES.includes(role))) return 'manager';
  if (roles.some((role) => SCHEDULER_USER_ROLES.includes(role))) return 'user';
  return undefined;
};

export const useSchedulerRole = (): SchedulerRole | undefined => {
  const { roles } = useUserRole();
  return deriveSchedulerRole(roles);
};
